import axios, {AxiosResponse, AxiosError} from 'axios';
import {HttpRequestHelper} from "../HttpRequestHelper";
import * as util from 'util';
import {
    JAPIExternalRecipientGetRecordByAuthCodeResponse,
    JAPIExternalRecipientGetRecordByEmailResponse,
    JAPIExternalRecipientUpdateRecordPlayedRequest,
    JAPIExternalRecipientUpdateRecordPlayedResponse,
    JAPIExternalRecipientUpdateRecordRedeemedResponse,
    JAPIExternalRecipientUpdateRecordViewedResponse
} from "platform_common/types/api/JAPIExternalRecipient";
import {Config} from "../../Config";


/**
 * Client side implementation for hitting external API
 * for recipient
 */
export class CAPIExternalRecipient {

    public static _basePath:string = Config.APIInternalBasePathPrefix + "/external";

    /**
     * Get specific Recipient Record by auth code.
     *
     * @param authCode
     */
    public static async getRecordByAuthCode(authCode:string):Promise<AxiosResponse<JAPIExternalRecipientGetRecordByAuthCodeResponse>|AxiosError> {

        try {
            // start with template URL for this call
            let urlTemplate:string = util.format('%s%s/recipient/auth_code/{authCode}', HttpRequestHelper.getAPI1BaseUrl(), CAPIExternalRecipient._basePath);

            // add parameters to final url
            let finalUrl:string = urlTemplate
                .replace('{authCode}', authCode);

            // get request options
            let requestOptions:any = HttpRequestHelper.buildGetHttpRequestOptions(finalUrl);

            // send request and get response
            return await axios(requestOptions);
        }
        catch (e) {
            return <AxiosError><any>e;
        }
    }

    /**
     * Get specific Recipient Record by email.
     *
     * @param email
     */
    public static async getRecordByEmail(email:string):Promise<AxiosResponse<JAPIExternalRecipientGetRecordByEmailResponse>|AxiosError> {

        try {
            // start with template URL for this call
            let urlTemplate:string = util.format('%s%s/recipient/email/{email}', HttpRequestHelper.getAPI1BaseUrl(), CAPIExternalRecipient._basePath);

            // add parameters to final url
            let finalUrl:string = urlTemplate
                .replace('{email}', email);

            // get request options
            let requestOptions:any = HttpRequestHelper.buildGetHttpRequestOptions(finalUrl);

            // send request and get response
            return await axios(requestOptions);
        }
        catch (e) {
            return <AxiosError><any>e;
        }
    }


    /**
     * Update existing  Recipient Record with Viewed info
     *
     * @param id
     */
    public static async updateRecordViewed(id:number):Promise<AxiosResponse<JAPIExternalRecipientUpdateRecordViewedResponse>|AxiosError> {

        try {
            // start with template URL for this call
            let urlTemplate:string = util.format('%s%s/recipient/id/{id}/viewed', HttpRequestHelper.getAPI1BaseUrl(), CAPIExternalRecipient._basePath);

            // add parameters to final url
            let finalUrl:string = urlTemplate
                .replace('{id}', id.toString());

            // get request options
            let requestOptions:any = HttpRequestHelper.buildPutHttpRequestOptionsJSON(finalUrl, {});

            // send request and get response
            return await axios(requestOptions);
        }
        catch (e) {
            return <AxiosError><any>e;
        }
    }

    /**
     * Update existing  Recipient Record with Randomly Set Puzzle
     *
     * @param id
     */
    public static async updateRecordSetPuzzle(id:number):Promise<AxiosResponse<JAPIExternalRecipientUpdateRecordViewedResponse>|AxiosError> {

        try {
            // start with template URL for this call
            let urlTemplate:string = util.format('%s%s/recipient/id/{id}/set_puzzle', HttpRequestHelper.getAPI1BaseUrl(), CAPIExternalRecipient._basePath);

            // add parameters to final url
            let finalUrl:string = urlTemplate
                .replace('{id}', id.toString());

            // get request options
            let requestOptions:any = HttpRequestHelper.buildPutHttpRequestOptionsJSON(finalUrl, {});

            // send request and get response
            return await axios(requestOptions);
        }
        catch (e) {
            return <AxiosError><any>e;
        }
    }

    /**
     * Update existing  Recipient Record with Played Info.
     *
     * @param id
     * @param secondsPlayed
     * @param puzzleSavePoint
     */
    public static async updateRecordPlayed(id:number, secondsPlayed:number, puzzleSavePoint:string):Promise<AxiosResponse<JAPIExternalRecipientUpdateRecordPlayedResponse>|AxiosError> {

        try {
            // start with template URL for this call
            let urlTemplate:string = util.format('%s%s/recipient/id/{id}/played', HttpRequestHelper.getAPI1BaseUrl(), CAPIExternalRecipient._basePath);

            // add parameters to final url
            let finalUrl:string = urlTemplate
                .replace('{id}', id.toString());

            // set request parameters
            let requestParams:JAPIExternalRecipientUpdateRecordPlayedRequest = {
                secondsPlayed: secondsPlayed,
                puzzleSavePoint: puzzleSavePoint
            };

            // get request options
            let requestOptions:any = HttpRequestHelper.buildPutHttpRequestOptionsJSON(finalUrl, requestParams);

            // send request and get response
            return await axios(requestOptions);
        }
        catch (e) {
            return <AxiosError><any>e;
        }
    }

    /**
     * Update existing  Recipient Record with Redeemed Info.
     *
     * @param id
     */
    public static async updateRecordRedeemed(id:number):Promise<AxiosResponse<JAPIExternalRecipientUpdateRecordRedeemedResponse>|AxiosError> {

        try {
            // start with template URL for this call
            let urlTemplate:string = util.format('%s%s/recipient/id/{id}/redeemed', HttpRequestHelper.getAPI1BaseUrl(), CAPIExternalRecipient._basePath);

            // add parameters to final url
            let finalUrl:string = urlTemplate
                .replace('{id}', id.toString());

            // get request options
            let requestOptions:any = HttpRequestHelper.buildPutHttpRequestOptionsJSON(finalUrl, {});

            // send request and get response
            return await axios(requestOptions);
        }
        catch (e) {
            return <AxiosError><any>e;
        }
    }

}
